export const AdminView = 'admin';
export const AdminPathname = `/${AdminView}`;
export const Tabs = 'tabs';

export const AdminTabs = `/${AdminView}/${Tabs}`;

